module.exports = __webpack_public_path__ + "static/jw-4f98fd44306bdcb8e6ffdc801cb361de.jpg";